import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const Wrapper = styled.div`
    section {
        [data-testid*='testing-area-section-message'] {
            width: 100%;
        }
    }
`;

export const InputWrapper = styled.div`
    display: flex;
    column-gap: ${token('space.050')};
    align-items: center;
    .issue-picker {
        min-width: 200px;
    }
`;

export const Text = styled.div`
    font-weight: 400;
    font-size: 14px;
    color: ${token('color.text')};
    margin-bottom: ${token('space.100')};
`;

export const ResultText = styled.div`
    font-weight: 500;
    font-size: 16px;
    color: ${token('color.text')};
    margin-bottom: ${token('space.100')};
    margin-top: ${token('space.500')};
    
`;